<template>
    <div class="container-fluid">
        <div class="pt-4 mb-4 d-flex justify-content-between">
            <div>
                <div class="col-md-12 mb-3">
                    <router-link class="back-route h3" ref="backBtn" to="" @click="$router.go(-1)">
                        <font-awesome-icon :icon="['fas', 'angle-left']" size="lg"/>
                        {{competition.name}}
                    </router-link>
                </div>
<!--                <div class="mx-3">-->
<!--                    <p>Descriptive Template &nbsp;&nbsp-->
<!--                        <router-link :to="'/templates/view/'+competition.template_id_view" class="linkViewTemplate">-->
<!--                            View Template-->
<!--                        </router-link>-->
<!--                    </p>-->
<!--                </div>-->
            </div>
            <div v-if="permissions.includes('create userscore')" class="btnOrganization">
                <button @click.prevent="SaveScore">
                    Save Score
                </button>
            </div>
            <div v-else></div>
        </div>

        <div class="row tabContent">
            <div class="tabContent1 mb-5">
                <div class="col-md-2">
                    <h4>Start Date</h4>
                    <h5>{{competition.start_date}}</h5>
                </div>
                <div class="col-md-2">
                    <h4>End Date</h4>
                    <h5>{{competition.end_date}}</h5>
                </div>
                <div class="col-md-2">
                    <h4>Start Time</h4>
                    <h5>{{competition.start_time}}</h5>
                </div>
                <div class="col-md-2" v-if="competition.duration != null">
                    <h4>Duration</h4>
                    <h5>{{competition.duration}} minutes</h5>
                </div>
                <div class="col-md-2" v-else>
                    <h4>Duration</h4>
                    <h5>{{durationInTime}} minutes</h5>
                </div>
                <div class="col-md-2">
                    <h4>Template Total Weight</h4>
                    <h5 v-if="scored != null">{{scored}}</h5>
                    <h5 v-else>Not Scored Yet</h5>
                </div>
            </div>
        </div>

        <div class="row pt-3">
            <div class="col-md-12">
                <h3>{{user.name}}</h3>
                <p>{{user.email}}</p>
            </div>
        </div>

        <div class="row">
            <QuestionsComponent v-if="renderFlag" :template="template" @isShown="isShown"/>
        </div>
    </div>

    <AlartModal v-if="showModal" :message="message" :imagePath="ImagePath" @close-modal="showModal = false"/>
</template>

<script>
    import QuestionsComponent from "./commonCoponents/questions";
    import score from "../../../api-services/score";
    import moment from "moment";
    import repository from "../../../api-services/repository";
    import getQuestionType from "../../../helpers/getQuestionType";
    import AlartModal from "../../components/AlartModal";

    export default {
        name: 'pageShow-userscore',
        data() {
            return {
                renderFlag: false,
                showModal:false,
                ImagePath:'',
                message:'',
                fullResult:0,
                fullMarkTrueOrFalse:0,
                fullMarkMultipleChoice:0,
                fullMarkFreeText:0,
                fullMarkArrange:0,
                fullMarkRank:0,
                permissions:[],
                isShown:false,
                template: {
                    name: '',
                    description: '',
                    questions: {
                        trueOrFalse: {
                            weight: 0,
                            title:'True Or False',
                            degree: 0,
                            questions: [],
                        },
                        multipleChoices: {
                            weight: 0,
                            title:'Multiple Choice',
                            degree: 0,
                            questions: []
                        },
                        freeText: {
                            weight: 0,
                            title:'Free Text',
                            degree: 0,
                            questions: [],
                        },
                        slides: {
                            weight: 0,
                            title:'Slides',
                            degree: 0,
                            name: '',
                            description: '',
                            images: [],
                            category: [],
                            slidesAnswersArray: [],
                            modelAnswerCategories: {},
                            answresUsersCategory: {}
                        },
                        rank: {
                            weight: 0,
                            title:'Rank',
                            questions: [],
                        },
                        arrange: {
                            weight: 0,
                            title:'Arrange',
                            questions: [],
                            modelAnswer: {},
                        },
                    }
                },
                slideAnswers:[],
                userAnswers:[],
                userArrangeAnswers:[],
                categoryIds:[],
                competition: {
                    name: null,
                    template_id_view: null,
                    start_date: null,
                    participant_type:null,
                    end_date: null,
                    start_time: null,
                    end_time: null,
                    duration: null,
                },
                scoreData:[],
                user:{
                    name:'',
                    email:''
                },
                durationInTime: null,
                scored:null,
                user_id:null,
                user_total_answers:[],
                bonus:0
            }
        },
        async mounted() {
            await this.$store.dispatch('activeTap', 'results');
            this.permissions = this.$store.state.auth.permissions;
            await this.getCompetitionData();
            await this.getScoreCompetitionData();
            const response = await repository.show('users',this.$route.params.id2);
            this.user.name = response.data.data.name;
            this.user.email = response.data.data.email;
            this.renderFlag = true;
            // await this.getTemplateData();
        },
        components: {
            QuestionsComponent,
            AlartModal
        },
        methods: {
            async SaveScore(){
                const competitionId = this.$route.params.id1;
                for(let i = 0 ; i < this.template.questions.freeText.questions.length ; i++){

                    console.log("dd ", this.template.questions.freeText.questions)
                    this.scoreData.push(
                        {
                            type: 3,
                            competition_training_id: this.$route.params.id1,
                            user_id:this.$route.params.id2,
                            score: this.template.questions.freeText.questions[i].degree,
                            question_id: this.template.questions.freeText.questions[i].id
                        }
                    );
                    this.fullMarkFreeText += this.template.questions.freeText.questions[i].degree;
                }
                console.log('====================================');
                const rank_ids= this.template.questions.rank.questions.map(el=>el.id)
                const rankquestions = this.user_total_answers.Q.filter(answer=>{
                    return rank_ids.includes(answer.question_id)
                })
                const rankquestionsSloved = rankquestions.filter(el=>el.value).length;
                this.bonus = (process.env.VUE_APP_BONUS*rankquestionsSloved/(rankquestions.length));
                for(let i = 0 ; i < this.template.questions.rank.questions.length ; i++){
                    this.scoreData.push(
                        {
                            type: 4,
                            competition_training_id: this.$route.params.id1,
                            user_id:this.$route.params.id2,
                            score: this.template.questions.rank.questions[i].degree,
                            question_id: this.template.questions.rank.questions[i].id
                        }
                    );
                    this.fullMarkRank += this.template.questions.rank.questions[i].degree;
                }
                this.fullResult = this.fullMarkTrueOrFalse + this.fullMarkMultipleChoice + this.fullMarkSlides + this.fullMarkArrange;
                this.user_id = this.$route.params.id2;

                await score.storeScoreCompetition(competitionId ,this.bonus, this.fullResult , this.fullMarkFreeText , this.fullMarkRank , this.user_id , this.competition.participant_type , {scoreData: this.scoreData});

                this.showModal = true;
                this.ImagePath = 'okImage.svg';
                this.message = 'score Saved Successfully';
                setTimeout(() => {
                    this.$router.go(-1);
                }, 2000);

            },
            async getScoreCompetitionData() {
                const competitionId = this.$route.params.id1;
                const user_id = this.$route.params.id2;
                try {
                    const responseCompetitionData = await score.getCompetitionScoreData(competitionId , user_id);
                    console.log(responseCompetitionData);
                    if(responseCompetitionData.data.data.length > 0){
                        this.scored = responseCompetitionData.data.data[0].free_text_score + responseCompetitionData.data.data[0].rank_score + responseCompetitionData.data.data[0].user_score;
                    }else {
                        // console.log('no score yet');
                    }
                } catch (e) {
                    // console.log({e})
                }
            },
            async getCompetitionData() {
                const competition_id = this.$route.params.id1;
                const user_id = this.$route.params.id2;
                try {
                    const response = await score.showUserCompetitionAnswers(competition_id, user_id);
                    this.user_total_answers = response.data.data;
                    // console.log("response========================================",{response});
                    this.competition.name = response.data.data.name;
                    this.competition.template_id_view = response.data.data.template.id;
                    this.competition.start_date = response.data.data.start_date;
                    this.competition.participant_type = response.data.data.participant_type;
                    this.competition.end_date = response.data.data.end_date;
                    this.competition.start_time = response.data.data.start_time;
                    this.competition.end_time = response.data.data.end_time;
                    this.competition.duration = response.data.data.duration;

                    this.slideAnswers = response.data.data.userAnswerSlides;
                    this.userArrangeAnswers = response.data.data.userArrangeAnswers;



                    if (this.competition.duration === null) {
                        let startTime = moment(this.competition.start_time, "HH:mm:ss a");
                        let endTime = moment(this.competition.end_time, "HH:mm:ss a");
                        let duration = moment.duration(endTime.diff(startTime));
                        let hours = parseInt(duration.asHours()) * 60;
                        let minutes = parseInt(duration.asMinutes()) % 60;

                        this.durationInTime = (hours + minutes);
                    }

                    response.data.data.template.questions.forEach((question) => {
                        if(question.type === '5'){
                            question.answers.forEach((ans, idx) => {
                                // this.template.questions.arrange.modelAnswer.push({
                                //     id: ans.id,
                                //     order: idx + 1
                                // })

                                this.template.questions.arrange.modelAnswer[ans.id] = idx + 1;

                            })
                        }
                    })

                    await this.formatData(response.data.data.template);

                    for (let j = 0; j < response.data.data.template.slides[0].attachments.length; j++) {
                        this.template.questions.slides.slidesAnswersArray[response.data.data.template.slides[0].attachments[j].id] = response.data.data.template.slides[0].attachments[j].path
                    }
                    // console.log(this.slidesAnswersArray);

                    for (let g = 0; g < response.data.data.template.slides[0].categories.length; g++) {
                        this.template.questions.slides.modelAnswerCategories[response.data.data.template.slides[0].attachments[g].id];
                    }

                } catch (e) {
                    // console.log(e);
                }
            },

            formatData(data) {
                let type = null;
                data.questions.forEach((q) => {
                    let qName = null;
                    type = getQuestionType(q.type);

                    this.template.questions[type].questions = [];
                });

                this.template.name = data.name;
                this.template.description = data.description;

                console.log("gQ ",  data.questions)
                data.questions.forEach((q) => {
                    // q.degree = 0;
                    type = getQuestionType(q.type);
                    this.template.questions[type].weight = q.weight;
                    this.template.questions[type].title = q.title;
                    if (q.type === "5")
                        q.degree = q.weight;

                    let isCorrect = false;
                    let isCorrectCount = 0;
                    let isSelectCount = 0;
                    let isMultiCorrectCount = 0;
                    let arrangeUserAns = [];
                    q.answers.forEach((ans) => {
                        arrangeUserAns = [];
                        ans.is_correct = ans.is_correct ? ans.is_correct : false;
                        ans.is_selected = ans.is_selected ? ans.is_selected : false ;

                        if (q.type === "1"){
                            isCorrect |= (ans.is_correct && ans.is_selected);
                            q.degree = isCorrect ?  (1 * this.template.questions[type].weight) : 0;

                            // console.log('d => ', q.degree)
                        }else if (q.type === "2"){
                            isCorrectCount += ans.is_correct ? 1 : 0;
                            isSelectCount += ans.is_selected ? 1 : 0;
                            isMultiCorrectCount  += (ans.is_correct && ans.is_selected) ? 1 : 0;

                            // console.log('d => ', q.degree)
                        }

                    });

                 if (q.type === "5"){
                        if( this.userArrangeAnswers.length > 0){

                            this.userArrangeAnswers.forEach( aAns => {
                                // if (aAns.id === q.id){
                                //     aAns.answers.forEach((arrangeAns) => {
                                if(q.id === aAns.question_id){
                                    let val = aAns.value;

                                    console.log("1- ", this.template.questions.arrange.modelAnswer)
                                    console.log("isOk - ", this.template.questions.arrange.modelAnswer[aAns.id] !== +val)
                                    console.log("2- ", val)
                                    console.log("3- ", aAns.id)
                                    console.log("4- ", q.id)
                                    aAns.value = aAns.originalValue;
                                    arrangeUserAns.push(aAns);
                                    // if (aAns.value !== aAns.originalValue){
                                    if(this.template.questions.arrange.modelAnswer[aAns.id] !== +val){
                                        q.degree = 0
                                    }
                                }
                                // })

                                // }

                            })
                        }else{
                            q.answers = [];
                            q.degree = 0
                        }

                    }

                    if (q.type === "5"){
                        console.log({arrangeUserAns})
                        q.answers = arrangeUserAns;
                        q.degree = arrangeUserAns.length ===  0 ? 0 : q.degree;
                    }
                    // console.log({isCorrectCount})
                    // console.log({isMultiCorrectCount})
                    if (q.type === "2")
                        q.degree = ((isSelectCount === isCorrectCount ) && (isSelectCount === isMultiCorrectCount ))?  (1 * this.template.questions[type].weight) : 0;

                    if (type !== 'freeText') {
                        this.template.questions[type].questions.push(
                            {
                                id:q.id,
                                question: q.content,
                                answers: q.answers,
                                degree: q.degree,
                            }
                        )
                    } else {
                        this.template.questions[type].questions.push(
                            {
                                id:q.id,
                                question: q.content,
                                answer: q.answers[0].value,
                                degree: q.degree
                            }
                        )
                    }
                });

                data.slides.forEach((slide) => {
                    this.template.questions['slides'].weight = slide.weight;
                    this.template.questions['slides'].name = slide.name;
                    this.template.questions['slides'].description = slide.description;
                    this.template.questions['slides'].images = slide.attachments;
                    this.template.questions['slides'].category = slide.categories;

                    slide.categories.forEach((cat) => {
                        let arr = []
                        cat.slide_categories.forEach((slide, idx) => {
                            let BreakException = {};
                            // console.log({slide}, {idx})
                            arr.push(slide.slide_attachment_id)

                            if( this.slideAnswers.length > 0){
                                try{
                                    this.slideAnswers.forEach((ans) => {
                                        // console.log({slide}, {ans}, {idx})
                                        if(+ans.category_id === +slide.category_id) {
                                            if (+ans.order === (idx + 1)) {
                                                slide.slide_attachment_id = ans.slide_attachment_id;
                                                throw BreakException;
                                            } else {
                                                // console.log('ssaaasss')
                                                slide.slide_attachment_id = null;
                                            }
                                        }else{
                                            slide.slide_attachment_id = null;
                                        }
                                    })
                                } catch (e) {
                                    if (e !== BreakException) throw e;
                                }
                            }else{
                                slide.slide_attachment_id = null;
                            }


                            // console.log('aaaa ', slide)
                        });

                        this.categoryIds.push(cat.id);
                        this.template.questions.slides.answresUsersCategory[cat.id] = [];
                        this.template.questions.slides.modelAnswerCategories[cat.id] = arr;
                    })
                });

                console.log("13 >>>>>>>>>>>>>>>>");

                this.slideAnswers.forEach((item) => {
                        this.template.questions.slides.answresUsersCategory[item.category_id].push(item.slide_attachment_id)
                });
                console.log("14 >>>>>>>>>>>>>>>>");

                // console.log('temp => ', this.template);
                // console.log('  this.slideAnswers => ',   this.slideAnswers);
                // console.log('  this.slideAnswers => ',    this.template.questions.slides);
                // console.log(' this.categoryIds => ',  this.categoryIds);

                for(let i = 0 ; i < this.template.questions.trueOrFalse.questions.length ; i++){
                    console.log('trueOrFalse => ',  this.template.questions.trueOrFalse.questions)

                    this.scoreData.push(
                        {
                            type: 1,
                            competition_training_id: this.$route.params.id1,
                            user_id:this.$route.params.id2,
                            score: this.template.questions.trueOrFalse.questions[i].degree,
                            question_id:this.template.questions.trueOrFalse.questions[i].answers[0].question_id
                        }
                    );
                    this.fullMarkTrueOrFalse += this.template.questions.trueOrFalse.questions[i].degree;
                }

                for(let i = 0 ; i < this.template.questions.multipleChoices.questions.length ; i++){

                    this.scoreData.push(
                        {
                            type: 2,
                            competition_training_id: this.$route.params.id1,
                            user_id:this.$route.params.id2,
                            score: this.template.questions.multipleChoices.questions[i].degree,
                            question_id:this.template.questions.multipleChoices.questions[i].answers[0].question_id
                        }
                    );
                    this.fullMarkMultipleChoice += this.template.questions.multipleChoices.questions[i].degree;
                }

                for(let i = 0 ; i < this.template.questions.arrange.questions.length ; i++){
                    // console.log('arrange => ',  this.template.questions.arrange.questions[i])

                    this.scoreData.push(
                        {
                            type: 5,
                            competition_training_id: this.$route.params.id1,
                            user_id:this.$route.params.id2,
                            score: this.template.questions.arrange.questions[i].degree,
                            question_id:this.template.questions.arrange.questions[i].id
                        }
                    );

                    console.log('scoreData => ',  this.scoreData)
                    this.fullMarkArrange += this.template.questions.arrange.questions[i].degree;
                }

                let correctSlide = 0;
                this.categoryIds.forEach(id => {
                    let check = false;
                    let intersection = this.template.questions.slides.modelAnswerCategories[id].filter(x => this.template.questions.slides.answresUsersCategory[id].includes(x));
                    check = intersection.length === this.template.questions.slides.modelAnswerCategories[id].length;
                    correctSlide += check ? 1 : 0;

                });

                if (correctSlide === this.template.questions.slides.category.length){
                    this.template.questions.slides.degree =  this.template.questions.slides.weight;
                    this.fullMarkSlides = this.template.questions.slides.weight;

                    this.scoreData.push(
                        {
                            type: 6,
                            competition_training_id: this.$route.params.id1,
                            user_id:this.$route.params.id2,
                            score: this.template.questions.slides.weight,
                            question_id: null
                        }
                    );
                }else {
                    this.template.questions.slides.degree = 0
                    this.fullMarkSlides = 0;
                    this.scoreData.push(
                        {
                            type: 6,
                            competition_training_id: this.$route.params.id1,
                            user_id:this.$route.params.id2,
                            score: 0,
                            question_id: null
                        }
                    );
                }

            },
        }

    }
</script>

<style scoped>
    .btnOrganization button {
        background-color: var(--btn-bg-color);
        color: var(--btn-text-color);
        border: none;
        border-radius: 5px;
        justify-content: end;
        align-content: center;
        padding: 10px;
    }

    .linkViewTemplate {
        color: #e65c00;
    }

    .tabContent1 {
        display: flex;
        flex-wrap: wrap;
        padding: 30px;
        height: 18vh;
        width: 100%;
        overflow-y: auto;
        background-image: linear-gradient(var(--secondary-bg1-color), var(--secondary-bg2-color));
        border: 1px solid #6F8896;
        border-radius: 10px;
        gap: 50px;
    }

    .tabContent {
        display: flex;
        padding: 30px;
        /*height: 80vh;*/
        background-image: linear-gradient(var(--secondary-bg1-color), var(--secondary-bg2-color));
        border-radius: 20px;
        /*height: 15vh;*/
        border: 1px solid var(--table-border);
    }

    .tabcontent {
        display: none;
        overflow-y: auto;
        height: 55vh;
        border-radius: 20px;
        background-image: linear-gradient(var(--secondary-bg1-color), var(--secondary-bg2-color));
        border: 1px solid var(--table-border);
    }
</style>